import { asset } from '$fresh/runtime.ts'
import type { JSX } from 'preact'

export type AvailableIcons =
    | 'Alert'
    | 'App'
    | 'Arrow'
    | 'ArrowDown'
    | 'ArrowLeft'
    | 'ArrowLeftCircle'
    | 'ArrowLeftCircleBg'
    | 'ArrowLeftCircleCart'
    | 'ArrowLeftCircleDark'
    | 'ArrowLeftVar'
    | 'ArrowRight'
    | 'ArrowRightCircle'
    | 'ArrowRightCircleBg'
    | 'ArrowRightCircleDark'
    | 'ArrowRightDown'
    | 'ArrowRightVar'
    | 'ArrowsPointingOut'
    | 'Bag'
    | 'BannerArrowLeft'
    | 'Bars3'
    | 'Bars3White'
    | 'Blog'
    | 'BlogWithB'
    | 'BreadcrumbArrow'
    | 'BuyTogetherChecked'
    | 'Card'
    | 'Chat'
    | 'Check'
    | 'Checked'
    | 'CheckoutBag'
    | 'CheckoutBuyTogetherEqual'
    | 'CheckoutBuyTogetherPlus'
    | 'CheckoutChevronDown'
    | 'CheckoutEdit'
    | 'CheckoutGift'
    | 'CheckoutHomePin'
    | 'CheckoutInputCheck'
    | 'CheckoutLock'
    | 'CheckoutMapPin'
    | 'CheckoutMapPinStar'
    | 'CheckoutMinus'
    | 'CheckoutMobileMinus'
    | 'CheckoutMobilePlus'
    | 'CheckoutMoney'
    | 'CheckoutPin'
    | 'CheckoutPlus'
    | 'CheckoutRedudantX'
    | 'CheckoutRefresh'
    | 'CheckoutShipping'
    | 'CheckoutTrash'
    | 'CheckoutUnion'
    | 'CheckoutWarning'
    | 'ChevronDown'
    | 'ChevronDownOld'
    | 'ChevronLeft'
    | 'ChevronRight'
    | 'ChevronUp'
    | 'Circle'
    | 'Clipboard'
    | 'Close'
    | 'Close-Cookie'
    | 'CollapsableArrow'
    | 'DebitCard'
    | 'Deco'
    | 'Delivery'
    | 'Diners'
    | 'Discord'
    | 'Discount'
    | 'DiscountTag'
    | 'DiscountWithBg'
    | 'DownloadApp'
    | 'EPlus'
    | 'Ellipse'
    | 'Elo'
    | 'Email'
    | 'Facebook'
    | 'FaleConosco'
    | 'Faq'
    | 'Filter'
    | 'FilterBars'
    | 'FilterList'
    | 'FindStore'
    | 'FindStoreWhite'
    | 'FreeShipping'
    | 'Gift'
    | 'Heart'
    | 'Help'
    | 'Home'
    | 'Horizontal3Bars'
    | 'House'
    | 'Hypercard'
    | 'InputError'
    | 'InputSuccess'
    | 'Instagram'
    | 'Iphone'
    | 'LayoutHorizontal'
    | 'LayoutMosaic'
    | 'LayoutSquare'
    | 'LetsEncrypt'
    | 'LinkProductAnalysis'
    | 'Linkedin'
    | 'Loading'
    | 'Location'
    | 'LocationPin'
    | 'Logo'
    | 'LogoNormalized'
    | 'MagnifyingGlass'
    | 'MagnifyingGlassOld'
    | 'MagnifyingGlassProductAnalysis'
    | 'Map'
    | 'MapPin'
    | 'Mastercard'
    | 'Microphone'
    | 'Minus'
    | 'OrderBy'
    | 'PaymentMethodsChevron'
    | 'Percent'
    | 'Person'
    | 'Phone'
    | 'PhoneCall'
    | 'Pix'
    | 'Plus'
    | 'ProductCard'
    | 'ProductZoom'
    | 'QuestionMarkCircle'
    | 'Questions'
    | 'Replace'
    | 'Return'
    | 'RoundCheck'
    | 'RoundedEmail'
    | 'Sac'
    | 'Sale'
    | 'Security'
    | 'ShoppingCart'
    | 'SizeArrowLeft'
    | 'SizeArrowRight'
    | 'SpecialCollection'
    | 'Spinner'
    | 'Store'
    | 'TableSearch'
    | 'Tiktok'
    | 'Timer'
    | 'TorraLogo'
    | 'TorraLogoBg'
    | 'TorraSkewFill'
    | 'Trash'
    | 'TriangleDown'
    | 'Trolley'
    | 'Truck'
    | 'TruckCheckout'
    | 'Twitter'
    | 'TwoCards'
    | 'User'
    | 'Vertical3Bars'
    | 'Vertical4Bars'
    | 'Visa'
    | 'Vtex'
    | 'VtexCertified'
    | 'WhatsApp'
    | 'WhatsAppPrimary'
    | 'Wishlist'
    | 'WishlistFill'
    | 'X'
    | 'XMark'
    | 'Youtube'
    | 'creditCard'
    | 'pixCard'
    | 'torraCard'
    | 'ChevronMicro'
    | 'URL'
    | 'Return'
    | 'Download'
    | 'Info'
    | 'Calculator'
    | 'Close-Shipping'
    | 'Smartphone'
    | 'CheckedApp'
    | 'DescChevronDown'
    | 'DescChevronUp'
    | 'SaleLinear'
    | 'SolarSaleLinear'


interface Props extends JSX.SVGAttributes<SVGSVGElement> {
    id: AvailableIcons
    size?: number
}

function Icon(
    { id, strokeWidth = 16, size, width, height, ...otherProps }: Props,
) {
    return (
        <svg
            {...otherProps}
            width={width ?? size}
            height={height ?? size}
            strokeWidth={strokeWidth}
        >
            <use href={asset(`/sprites.svg#${id}`)} />
            <title>{id}</title>
        </svg>
    )
}

export default Icon
